import CombineReducers from "../combine_reducer/combineReducer";
import { createStore } from 'redux';

const store = createStore(CombineReducers);

export default store;